// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"FMHeaderGoBe_outerContainer__34aV5","innerImgContainer":"FMHeaderGoBe_innerImgContainer__3GJVl","innerMsgContainer":"FMHeaderGoBe_innerMsgContainer__2XzjV"};